import React, { useContext, useEffect, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { TablePagination, Loading } from '../Library'
import { Form, Row, Col, Button, Table } from 'react-bootstrap'
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper } from '@fortawesome/free-solid-svg-icons'
import { listNewsLog } from '../Network/Log'
import { listCompany } from '../Network/Company'
import "./NewsLog.css"
import dayjs from 'dayjs';

function NewsLog() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.activity_log
    const notify = useContext(NotifyContext)

    const [isLoading, setLoading] = useState(false)
    const [content, setContent] = useState([])
    const [companyList, setCompanyList] = useState([])

    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [type, setType] = useState("ALL")
    const [selectCompany, setSelectCompany] = useState("")
    const [newsTitle, setNewsTitle] = useState("")

    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 15
    const totalPage = Math.ceil(content.length / perPage)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage

    const typeChoices = [
        { value: "ALL", label: lang.all },
        { value: "INFORM", label: lang.inform },
        { value: "REGISTER", label: lang.register },
        { value: "VOTE", label: lang.vote },
        { value: "QUIZ", label: lang.quiz }
    ]

    const fetchData = (startDate, endDate, companyId, title, type, isExport) =>{
        setLoading(true)
        listNewsLog(startDate, endDate, companyId, title, type, isExport,
            (data)=>{
                if(!isExport){
                    setContent(data)
                }
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    const fetchCompany = () =>{
        listCompany(
            (data)=>{ setCompanyList(data) },
            (error)=>{}
        )
    }

    const previewFilter = () =>{
        fetchData(startDate, endDate, selectCompany, newsTitle, type, false)
    }

    const clearFilter = () =>{
        setStartDate(null)
        setEndDate(null)
        setSelectCompany("")
        setType("ALL")
        setNewsTitle("")
        fetchData(null, null, "", "", "ALL", false)
    }

    const exportExcel = () =>{
        fetchData(startDate, endDate, selectCompany, newsTitle, type, true)
    }

    useEffect(()=>{
        const fetchData = (startDate, endDate, companyId, title, type, isExport) =>{
            setLoading(true)
            listNewsLog(startDate, endDate, companyId, title, type, isExport,
                (data)=>{
                    if(!isExport){
                        setContent(data)
                    }
                    setLoading(false)
                },
                (error)=>{
                    notify.showNotify("Something wrong", error.message, 2)
                    setLoading(false)
                })
        }

        fetchData(startDate, endDate, selectCompany, newsTitle, type, false)
        fetchCompany()
    },[startDate, endDate, selectCompany, newsTitle, type, notify])

    return (
        <div id="news-log">
            { isLoading ? <Loading/>: null }
            <div>{lang.news_log_desc}</div>
            <Row className="filter-section">
                <Col lg={6} xl={4}>
                    <Form.Group>
                        <Form.Label>{lang.start_datetime}</Form.Label>
                        <DatePicker
                        className="form-control"
                        showTimeSelect
                        placeholderText={lang.choose_datetime}
                        selected={startDate}
                        dateFormat="d MMMM yyyy H:mm"
                        onChange={(date)=>setStartDate(date)}
                        maxDate={new Date()}
                        />
                    </Form.Group>
                </Col>
                <Col lg={6} xl={4}>
                    <Form.Group>
                        <Form.Label>{lang.end_datetime}</Form.Label>
                        <DatePicker
                        className="form-control"
                        showTimeSelect
                        placeholderText={lang.choose_datetime}
                        selected={endDate}
                        dateFormat="d MMMM yyyy H:mm"
                        onChange={(date)=>setEndDate(date)}
                        minDate={startDate}
                        maxDate={new Date()}
                        />
                    </Form.Group>
                </Col>
                <Col lg={6} xl={4}>
                    <Form.Group>
                        <Form.Label>{lang.type}</Form.Label>
                        <Form.Control 
                        as="select"
                        value={type}
                        onChange={(e)=>setType(e.target.value)}>
                            { typeChoices.map((item, key)=>
                            <option key={key} value={item.value}>{item.label}</option>   
                            )}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col lg={6} xl={4}>
                    <Form.Group>
                        <Form.Label>{lang.company}</Form.Label>
                        <Form.Control as="select"
                        value={selectCompany}
                        onChange={(e)=>setSelectCompany(e.target.value)}>
                            <option value="">{lang.choose_company}</option>
                            { companyList.map((item, key) =>
                            <option key={key} value={item.id}>{item.name}</option>
                            )}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col lg={6} xl={4}>
                    <Form.Group>
                        <Form.Label>{lang.news_title}</Form.Label>
                        <Form.Control 
                        value={newsTitle}
                        onChange={(e)=>setNewsTitle(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <div>
                <Button style={{ marginRight: 10 }} onClick={()=>previewFilter()}>
                    {lang.preview}
                </Button>
                <Button style={{ marginRight: 10 }} variant="secondary" onClick={()=>clearFilter()}>
                    {lang.clear}
                </Button>
                <Button variant="success" onClick={()=>exportExcel()}>
                    {lang.get_excel}
                </Button>
            </div>
            <div className="table-container">
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.news}</th>
                            <th>{lang.first_name}</th>
                            <th>{lang.last_name}</th>
                            <th>{lang.email}</th>
                            <th>{lang.interact_date}</th>
                        </tr>

                    </thead>
                    <tbody>
                        { content.slice(indexOfFirst, indexOfLast).map((item, key)=>
                        <NewsLogItem
                        key={key}
                        news={item.title}
                        firstName={item.firstName}
                        lastName={item.lastName}
                        email={item.email}
                        interactDate={item.createdDate}
                        />
                        )}
                        { content.length === 0 ?
                        <tr style={{ textAlign: 'center' }}>
                            <td colSpan={6}>{lang.no_news_log}</td>
                        </tr>
                        : null
                        }
                    </tbody>
                </Table>
            </div>
            <div>
                <TablePagination
                dataLength={totalPage}
                size={10}
                currentPage={currentPage}
                handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                firstPageClick={(first)=>{ setCurrentPage(first) }}
                lastPageClick={(last)=>{ setCurrentPage(last) }}
                disabledPrev={currentPage === indexOfFirst + 1}
                disabledNext={currentPage === totalPage}/>
            </div>
        </div>
    )
}

function NewsLogItem({ news, firstName, lastName, email, interactDate }){
    return(
        <tr>
            <td>
                <FontAwesomeIcon icon={faNewspaper}/>
            </td>
            <td>{news}</td>
            <td>{firstName}</td>
            <td>{lastName}</td>
            <td>{email}</td>
            <td>{dayjs(interactDate).format("D MMM YYYY - H:mm")}</td>

        </tr>
    )
}

export default NewsLog
